
export { HorizontalProductCardSkeleton } from "/codebuild/output/src3632624141/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src3632624141/src/packages/shared-components/src/components/ProductCard/index.ts"